export default __webpack_public_path__ + "static/media/852hz-awakenintuition.ab163d0f.jpg";